import Wrapper from "../../Wrapper";

 const TripControlSystem = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Trip Control System</h3>
         </Wrapper>
         </>
     );
 }
 export default TripControlSystem;